import { Component, OnInit, Input } from '@angular/core';
import { CursoService } from "../../servicios/curso.service";
import { ActivatedRoute } from "@angular/router";
import { Observable } from 'rxjs';
import { cursoI } from 'src/app/shared/models/curso.interface';
import { CursoUsuarioService } from 'src/app/servicios/curso-usuario.service';


@Component({
  selector: 'app-curso',
  templateUrl: './curso.component.html',
  styleUrls: ['./curso.component.scss']
})
export class CursoComponent implements OnInit {

 // public cursos$: Observable<cursoI[]>
  @Input() curso:cursoI; 

  constructor(private cursosvc:CursoService, private cursoUsrSvc:CursoUsuarioService) { }

  ngOnInit(): void {  
    //console.log("entro a las notas cheeeeee");
    
   // this.cursos$ = this.cursosvc.getAllCursos();
  }

}
